





















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import PatientByIdFinder from "./PatientByIdFinder.vue";
import PatientByNameFinder from "./PatientByNameFinder.vue";

@Component({
  components: {
    PatientByIdFinder,
    PatientByNameFinder,
  }
})
export default class PatientFinder extends Mixins(ModelEditableMixin) {
  @Prop()
  patientNo: string;

  @Prop()
  patientName: string;

  @Prop({ default: false })
  shouldUseNameOnly: boolean;

  data(): any {
    return { isByName: this.shouldUseNameOnly, };
  }
  isByName: boolean;
  
  focusToInput(): void {
    if (this.isByName) {
      (this.$refs.nameFinder as PatientByNameFinder).focusToPatientName();
    } else {
      (this.$refs.finder as PatientByIdFinder).focusToPatientId();
    }
  }

  get isNameEnable(): boolean {
    return this.$configuration.behavior.patient.finder.name.isEnable;
  }

  get shouldShowSearchCondition(): boolean {
    return this.isNameEnable && !this.shouldUseNameOnly;
  }

  get idFinderStyle() {
    return this.isNameEnable
      ? null
      : { margin: "25px 0px 0px 0px" };
  }
}
